import { useNavigation, useOne } from "@refinedev/core";
import { Alert, Button, Card, Steps } from "antd";
import {
  isOrderUploadTerminal,
  ORDER_UPLOAD_STAGE_LABELS,
} from "constants/orderUploadStages";
import { IOrderUploadStatus } from "interfaces";
import React from "react";

const STEP_INDEX: Record<string, number> = {
  uploaded: 0,
  processing: 1,
  validating: 1,
  validation_failed: 1,
  submitting_to_ukho: 2,
  ukho_errors: 2,
  issuing_permits: 3,
  fulfilled: 4,
  failed: 4,
};

const FAILED_STAGES = ["validation_failed", "ukho_errors", "failed"];

export const OrderUploadProgress: React.FC<{
  uploadStatusId: number | null;
}> = ({ uploadStatusId }) => {
  const { show } = useNavigation();

  const { result } = useOne<IOrderUploadStatus>({
    resource: "order-upload-status",
    id: uploadStatusId ?? "",
    queryOptions: {
      enabled: uploadStatusId != null,
      refetchInterval: ((query: any) =>
        isOrderUploadTerminal(query?.state?.data?.data?.stage)
          ? false
          : 3000) as any,
    },
  });

  if (uploadStatusId == null) {
    return null;
  }

  const record = result;
  const stage = record?.stage ?? "uploaded";
  const hasFailed = FAILED_STAGES.includes(stage);

  return (
    <Card title="Order processing status" size="small" style={{ marginTop: 20 }}>
      <Steps
        size="small"
        current={STEP_INDEX[stage] ?? 0}
        status={hasFailed ? "error" : stage === "fulfilled" ? "finish" : "process"}
        items={[
          { title: "Uploaded" },
          { title: "Validating" },
          { title: "Submitting to UKHO" },
          { title: "Issuing permits" },
          { title: "Result" },
        ]}
      />
      {hasFailed && (
        <Alert
          style={{ marginTop: 16 }}
          type="error"
          message={ORDER_UPLOAD_STAGE_LABELS[stage] ?? stage}
          description={
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {(record?.errors ?? []).map((error, index) => (
                <li key={index}>
                  {error.source ? `[${error.source}] ` : ""}
                  {error.message}
                </li>
              ))}
            </ul>
          }
        />
      )}
      {stage === "fulfilled" && (
        <Alert
          style={{ marginTop: 16 }}
          type="success"
          message="Order fulfilled by UKHO"
          action={
            record?.orderId ? (
              <Button
                size="small"
                onClick={() => show("order", record.orderId as number)}
              >
                View order
              </Button>
            ) : undefined
          }
        />
      )}
    </Card>
  );
};
